export const en = {
  modules: [
    {
      template: 'authorModule',
      text: `<p>
                Film Directed by <strong>Mohammad Gorjestani</strong>, Article Written by <strong>Rudy Mondragon</strong>, Article Edited by <strong>Sean Conroy</strong>, Photography by <strong>Jeff Mercado</strong>
             </p>`
    },
    {
      template: 'leadModule',
      body: `“Lowriding started here, in Los Angeles. It’s American history. It’s an American pastime.”`
    },
    {
      template: 'textModule',
      leftImage: {
        width: 262,
        height: 398,
        url: 'assets/images/story/story-badhombre/badhombre-side-image1.jpg',
        alt: 'Punch posing next to a lowrider wheel'
      },
      text: `<p>
                This is a story about reinvention. It’s a story about lowriders, a practice built around the remaking of American cars. It’s a story about a man named Wilson, who is also known as “Punch,” who didn’t think he’d live past 21, and who has rehabilitated himself into a loving father of three children.</p>
            <p>
                Lowriding was born in the Chicano barrios of Los Angeles after World War II. Servicemen returning from the war brought with them specialized mechanical skills, which translated easily into the just beginning practice of car customizations. Lowriders became the vehicle of choice for pachucos, rebellious Mexican-American youth.
            </p>
            <p>
                Punch himself isn’t Mexican-American—his parents were born in El Salvador, and he was born in LA. Ever since he spotted his first one at the age of 11, his passion has been for customized, handpainted, kitted-out sedans that bounce on hydraulic jacks—lowriders.
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 640,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery1-1.jpg',
          index: '01',
          alt: 'The front end of a lowrider lifts into the air',
          caption: `<p>A lowrider competes in a hop contest.</p>`
        },
        {
          width: 426,
          height: 641,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery1-2.jpg',
          index: '02',
          alt: 'Wilson, a.k.a. Punch, sitting inside a lowrider',
          caption: `<p>Wilson, a.k.a. Punch, grew up in the lowrider culture of West Los Angeles.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: `Seeing a car that’s abandoned and left for dead, I can bring that car back to life. For some of us that’s kind of a representation of yourself, your struggle. That’s what lowriding is.`,
      cite: 'Punch'
    },
    {
      template: 'textModule',
      text: `<p>
                Early lowriders added heavy blocks (anything from sandbags to bricks) to make the car ride lower—and the added weight, of course, slowed the cars down. Riding “low and slow” played as a kind of statement against the dominant Anglo car culture at the time, which was focused on speed. Later, a customizer figured out how to raise and lower the car’s height with the flip of a switch by using hydraulic pumps and valves left over from World War II-era planes.              
            <p>
                Lowriders are always American made, usually General Motors models. Those hydraulic switches originated from great American machinery. It was started in America and is practiced by Americans. As Punch says, “Lowriding is an American pastime.” And though it’s born of the Mexican-American community, it isn’t only enjoyed by Mexican-Americans; Punch isn’t Mexican-American, and there is a rich and shared history of lowriding in the African American community, too. These communities have been historically disenfranchised, made up of socioeconomic outsiders.
            </p>
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 324,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery2-1.jpg',
          index: '01',
          alt: 'Bumper detail of a classic lowrider',
          caption: `<p>Chrome and color.</p>`
        },
        {
          width: 426,
          height: 324,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery2-2.jpg',
          index: '02',
          alt: 'Orange lowrider crusing down a street',
          caption: `<p>Cruising.</p>`
        },
        {
          width: 426,
          height: 324,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery2-3.jpg',
          index: '03',
          alt: 'Man steps out of a lowrider',
          caption: `<p>Style and swagger.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: `You hit that corner, and people are looking at you, they’re stopping what they're doing. And you want to be heard, and you want to be seen. You’re a king, and the car is your throne.`,
      cite: 'Punch'
    },
    {
      template: 'textModule',
      text: `<p>
               "Everybody had a number in mind when they were gonna be killed. My number was 21.” His best friend was killed at 21.           
            <p>
                Then, when Punch was 21, he was carjacked. Someone pulled a gun on him at a gas station and drove away with his 1983 Cutlass Supreme Brougham—his most prized lowrider. Years of hard struggle with drugs and gang life followed. “I got myself into a lot of predicaments where I shouldn’t have come out. I was actually looking for it maybe at times. You know what I mean? Because I couldn’t find a way out.”
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 640,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery3-1.jpg',
          index: '01',
          alt: 'Punch leans reflectively against his lowrider',
          caption: `<p>Punch in his home neighborhood of West Los Angeles.</p>`
        },
        {
          width: 426,
          height: 639,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery3-2.jpg',
          index: '02',
          alt: 'Punch and his wife, Evelyn, embrace on the couch.',
          caption: `<p>Punch and his wife, Evelyn.</p>`
        }
      ]
    },
    {
      template: 'textModule',
      text: `<p>
                His wife and partner of twenty-plus years, Evelyn, may be the only reason he made it past his bleak magic number of 21. “She saw something in me that I still don’t see in myself,” Punch explains. “There is no me without her.” 
            </p>
            <p>
                When Evelyn got pregnant, everything changed. Evelyn and Punch have three children together: Richie was born deaf, Darlin with cerebral palsy, and Heaven was born premature at six months. They lost another to miscarriage. His children are also the reason for Punch’s personal revival. He got clean. He started his own trucking business. He drives for Lyft. He has purpose now: fatherhood.   
            </p>
            <p>
                “If it wasn't for my children's disabilities, we wouldn’t have these doors open now,” Punch says. “My children have pretty much have paved our way, you know what I mean? They’re taking us down this road that I’ve never expected I would take. But it's important that we go down it.” Punch and Evelyn push their children to do well academically (Darlin just graduated high school), and they are active with <a href="https://deaflatinosyfamilias.org/" target="_blank">Deaf Latinos y Familias</a>, an organization that works with families with deaf children.  
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 640,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery4-1.jpg',
          index: '01',
          alt: 'Punch and his son pose in front of a 1978 Chevy Monte Carlo which they are repairing',
          caption: `<p>Punch and his son, Richie, work on restoring a 1978 Chevy Monte Carlo.</p>`
        },
        {
          width: 426,
          height: 639,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery4-2.jpg',
          index: '02',
          alt: 'Evelyn and daughter, Heaven, sitting on the front porch',
          caption: `<p>Evelyn with their daughter, Heaven.</p>`
        },
        {
          width: 426,
          height: 639,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery4-3.jpg',
          index: '03',
          alt: 'Punch and his son, Darlin',
          caption: `<p>Punch with his son, Darlin</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: `I want you to see me. I want you to hear me. I want you to see that no matter what you thought about me or how I was going to end up, either in jail or dead, I’m still here and I’m doing something positive—and that’s what I’m passing down to my kids.`,
      cite: 'Punch'
    },
    {
      template: 'textModule',
      text: `<p>
                Building a lowrider is an exercise in creative resurrection—and redefinition. It’s about taking something—a staid, American sedan—and the expectations about what it’s supposed to represent, and redesigning it according to one’s own imagination. It’s an exercise in reclamation, too, including what it means for something to be considered “American.” Says Punch: “When you pick up this car from nothing, and you have this vision, and you bring it back to life, and it’s actually there, and you’re bouncing around in it…it’s a great feeling, man. I can’t even describe it to you.” 
            </p>
            <p>
                Today, Punch is rebuilding a 1978 Chevy Monte Carlo with his son, Richie. Piecing together a lowrider is painstaking and expensive, and Punch knows it could take them years to finish it. Tremendous skill is required, both technical and artistic—and plenty of stubborn resilience, too. Many lowriders are never finished at all; they are works in progress, existing in a perpetual state of  tinkering. A perpetual state of improvement. Like Punch’s new mindset: “I mean, I f*cked up more than I’ve done good. Now I’m just trying to do good. You know what I mean?”
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 640,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery5-1.jpg',
          index: '01',
          alt: 'Punch and Evelyn pose in their front yard',
          caption: `<p>Punch and Evelyn in their front yard.</p>`
        },
        {
          width: 426,
          height: 325,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery5-2.jpg',
          index: '02',
          alt: 'Punch, Evelyn, and their three children sitting in a lowrider, displaying the West Side sign',
          caption: `<p>Punch, Evelyn, Richie, Darlin, and Heaven.</p>`
        }
      ]
    },
    {
      template: 'donateModule',
      title: 'Make a Donation',
      subtitle: 'And join our efforts',
      body: `<p> 
                Every issue contributing to our current immigration crisis is interconnected. Your stories inspire us to continue to take a stand — when our community of riders and drivers is threatened, we’re encouraged to take action.   
                <br><br>
                In honor of Punch and his family, we’re humbled to support <a href="https://deaflatinosyfamilias.org/" target="_blank">Deaf Latinos y Familias</a>, an organization providing free American Sign Language education to help Latino families share traditions, stories, and history with deaf and hard-of-hearing children and adults.
                <br><br>
                Lyft is honored to offer transportation support for Deaf Latinos y Familias' vital mission. Please join us in supporting them.
             </p>`,
      cta: 'Make a donation',
      url: 'https://deaflatinosyfamilias.org/support'
    },
    {
      template: 'nextStoryModule',
      id: 'story-twin-cities',
      title: 'Life After 1991',
      location: 'Twin Cities, MN',
      alt: 'Woman with basketball',
      description: 'Diaspora in the Twin Cities',
      imageSize1URL: 'assets/images/carousel/carousel-image-twin-cities-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-twin-cities-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/344699878.sd.mp4?s=7ed73e4052345395d4a29f2d53f2ff61fe2d38de&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/345095138.sd.mp4?s=1f2d61726cb7ea2c00e131b951ca03b9b573d4a9&profile_id=165'
    }
  ]
};

export const es = {
  modules: [
    {
      template: 'authorModule',
      text: `<p>
                Dirigido por <strong>Mohammad Gorjestani</strong>, Artículo escrito por <strong>Rudy Mondragon</strong>, Artículo editado por <strong>Sean Conroy</strong>, Fotografía de <strong>Jeff Mercado</strong>
             </p>`
    },
    {
      template: 'leadModule',
      body: `"La tradición de armar lowriders empezó aquí, en Los Ángeles. Es parte de la historia de Estados Unidos. Es un pasatiempo estadounidense".`
    },
    {
      template: 'textModule',
      leftImage: {
        width: 262,
        height: 398,
        url: 'assets/images/story/story-badhombre/badhombre-side-image1.jpg',
        alt: 'Punch posando junto a un rin de lowrider'
      },
      text: `<p>
                Esta es una historia sobre reinvención. Es una historia sobre lowriders, una práctica que gira en torno a volver a crear los autos estadounidenses. Es una historia sobre un hombre llamado Wilson, a quien apodan "Punch", que creía que no llegaría a vivir más de 21 años y que hoy, se ha rehabilitado a sí mismo en un padre amoroso de tres hijos.
            </p>
            <p>
                El armado de lowriders nació en los barrios chicanos de Los Ángeles después de la Segunda Guerra Mundial. Los soldados que regresaban de la guerra trajeron con ellos nuevas habilidades mecánicas que se convirtieron en la incipiente práctica de la personalización de autos. Los lowriders se convirtieron en el vehículo favorito de los pachucos, los jóvenes rebeldes mexicano-estadounidenses.
            </p>
            <p>
                De hecho, Punch no es mexico-estadounidense, sus padres nacieron en El Salvador, y él nació en Los Ángeles. Desde que vio su primer lowrider, cuando apenas tenía 11 años de edad, se apasionó totalmente por esos característicos sedanes personalizados, pintados a mano y equipados con hidráulicos que los hacen rebotar.
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 640,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery1-1.jpg',
          index: '01',
          alt: 'El extremo delantero de un lowrider se eleva en el aire',
          caption: `<p>Un lowrider compite en un concurso de saltos.</p>`
        },
        {
          width: 426,
          height: 641,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery1-2.jpg',
          index: '02',
          alt: 'Wilson, alias Punch, sentado dentro de un lowrider',
          caption: `<p>Wilson, alias Punch, creció inmerso en la cultura de los lowriders del oeste de Los Ángeles.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: `Cuando veo un auto abandonado y dado por muerto, sé que puedo devolverle la vida a ese auto. Para algunos de nosotros, esa es la representación de uno mismo, tu lucha. De eso se trata el armar lowriders.`,
      cite: 'Punch'
    },
    {
      template: 'textModule',
      text: `<p>
                Los primeros lowriders incorporaban bloques pesados (cualquier cosa desde sacos de arena hasta ladrillos) para hacer que el auto viajara más cerca del piso, y el peso adicional hacía que estos se desplazaran más despacio. El viajar "abajo y despacio" jugó como una especie de declaración contra la cultura dominante automotriz anglo de ese momento, que estaba más enfocada en la velocidad. Más tarde, un personalizador descubrió cómo subir y bajar la altura del auto con solo tocar un botón, usando bombas hidráulicas y válvulas pertenecientes a aviones olvidados de la Segunda Guerra Mundial.              
            <p>
                Los lowriders siempre son de fabricación estadounidense, generalmente de modelos General Motors. Sus interruptores hidráulicos se originaron de la gran maquinaria estadounidense. Empezaron en los Estados Unidos y los siguen usando los estadounidenses. Como dice Punch, "el Lowriding es un pasatiempo estadounidense". Y aunque nace de la comunidad mexicano-estadounidense, no solo lo disfruta ese grupo; de hecho, Punch no es mexicano-estadounidense, y la comunidad afroamericana también comparte una historia rica con los lowriders. Históricamente, estas comunidades y las personas que las conforman han sido marginadas.
            </p>
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 324,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery2-1.jpg',
          index: '01',
          alt: 'Detalle del parachoque de un lowrider clásico',
          caption: `<p>El cromado y el color.</p>`
        },
        {
          width: 426,
          height: 324,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery2-2.jpg',
          index: '02',
          alt: 'Lowrider color naranja en una calle',
          caption: `<p>Paseando.</p>`
        },
        {
          width: 426,
          height: 324,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery2-3.jpg',
          index: '03',
          alt: 'El hombre sale de un lowrider',
          caption: `<p>Estilo y pavoneo.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: `Llegas a esa esquina y la gente te voltea a ver, dejando de hacer lo que estaba haciendo. Y quieres que te escuchen y que te vean. Eres un rey, y el auto es tu trono.`,
      cite: 'Punch'
    },
    {
      template: 'textModule',
      text: `<p>
               "Todos teníamos un número en mente de cuándo íbamos a ser asesinados. El mío era 21". Su mejor amigo fue asesinado a los 21.           
            <p>
                Después, cuando Punch tenía 21 años, le robaron su auto con violencia. Alguien lo amenazó con una pistola en una gasolinera y se llevó su Cutlass Supreme Brougham '83; su lowrider más preciado. Siguieron años de luchar con drogas y de vivir con pandillas. "Me metí en muchos problemas de los que no debería haber salido". De hecho, era como si me lo hubiera estado buscando a veces. ¿Sabes a lo que me refiero? Porque no podía encontrar una salida".
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 640,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery3-1.jpg',
          index: '01',
          alt: 'Punch se recuesta pensativamente en su lowrider',
          caption: `<p>Punch en su barrio natal del oeste de Los Ángeles.</p>`
        },
        {
          width: 426,
          height: 639,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery3-2.jpg',
          index: '02',
          alt: 'Punch y su esposa, Evelyn, se abrazan en el sofá.',
          caption: `<p>Punch y su esposa, Evelyn.</p>`
        }
      ]
    },
    {
      template: 'textModule',
      text: `<p>
                Quizá la única razón por la que superó su sombrío número mágico de 21 fue Evelyn, su esposa y pareja por más de veinte años. "Ella vio algo en mí que todavía no puedo ver yo", explica Punch. "No hay un yo sin ella". 
            </p>
            <p>
                Cuando Evelyn se embarazó, todo cambió. Evelyn y Punch tienen tres hijos juntos: Richie nació sordo, Darlin con parálisis cerebral y Heaven nació prematura a los seis meses. Perdieron un bebé más por un aborto involuntario. Sus hijos también son la razón del renacimiento personal de Punch. Dejó de usar drogas y alcohol. Empezó su propio negocio de vehículos. Maneja para Lyft. Y ahora tiene un propósito de vida: la paternidad.   
            </p>
            <p>
                "Si no fuera por las discapacidades de mis hijos, no tendríamos estas puertas abiertas", dice Punch. "Básicamente, mis hijos nos allanaron el camino, ¿sabes a qué me refiero? Nos están llevando por un camino que jamás pensé tomar. Pero es importante que lo recorramos”. Punch y Evelyn motivan a sus hijos para que tengan un buen desempeño académico (Darlin acaba de graduarse de la secundaria), y se mantienen activos con la organización <a href="https://deaflatinosyfamilias.org/" target="_blank">Deaf Latinos y Familias</a>, que trabaja con familias con niños sordos.  
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 640,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery4-1.jpg',
          index: '01',
          alt: `'Punch y su hijo posan frente a un Chevy Monte Carlo '78 que están reparando'`,
          caption: `<p>Punch y su hijo Richie trabajan en restaurar un Chevy Monte Carlo '78.</p>`
        },
        {
          width: 426,
          height: 639,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery4-2.jpg',
          index: '02',
          alt: 'Evelyn y su hija Heaven sentadas en el pórtico de la entrada',
          caption: `<p>Evelyn con su hija Heaven.</p>`
        },
        {
          width: 426,
          height: 639,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery4-3.jpg',
          index: '03',
          alt: 'Punch y su hijo Darlin.',
          caption: `<p>Punch con su hijo Darlin</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: `Quiero que me veas. Quiero que me escuches. Quiero que veas que no importa lo que pienses de mí o cómo voy a terminar, ya sea en la cárcel o muerto, todavía estoy aquí y estoy haciendo algo positivo, y eso es lo que quiero transmitirle a mis hijos.`,
      cite: 'Punch'
    },
    {
      template: 'textModule',
      text: `<p>
                Armar un lowrider es un ejercicio de resurrección y de redefinición creativa. Se trata de tomar algo —un sedán estadounidense serio y las expectativas que se supone debe representar— y de rediseñarlo como te dicte tu propia imaginación. También es un ejercicio de recuperación, que incluye aquello que significa ser "estadounidense". Dice Punch: "Cuando tomas este auto de la nada y tienes esta visión y le devuelves la vida, y allí está, y estás arriba rebotando en él... es un gran sentimiento, hermano. Ni siquiera lo puedo describir. 
            </p>
            <p>
                Hoy, Punch está reconstruyendo un Chevy Monte Carlo de 1978 con su hijo Richie. Armar un lowrider es un trabajo duro y caro, y Punch sabe que le puede llevar años terminarlo. Se requieren increíbles habilidades, tanto técnicas como artísticas, además de mucha resiliencia y algo de necedad. Muchos lowriders nunca se completan en su totalidad; son obras en proceso que existen en un estado perpetuo de retoques. Un estado de mejora perpetuo. Al igual que la nueva mentalidad de Punch: "Quiero decir, la he c*gado más de lo que he hecho bien. Ahora solo estoy tratando de hacer el bien. ¿Sabes a lo que me refiero?".
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 640,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery5-1.jpg',
          index: '01',
          alt: 'Punch y Evelyn posan en su patio delantero',
          caption: `<p>Punch y Evelyn en su patio delantero.</p>`
        },
        {
          width: 426,
          height: 325,
          url: 'assets/images/story/story-badhombre/badhombre-image-gallery5-2.jpg',
          index: '02',
          alt: 'Punch, Evelyn y sus tres hijos sentados en un lowrider, haciendo la seña del lado oeste',
          caption: `<p>Punch, Evelyn, Richie, Darlin y Heaven.</p>`
        }
      ]
    },
    {
      template: 'donateModule',
      title: 'Haz una donación',
      subtitle: 'Unete a nuestra causa',
      body: `<p> 
                Todos los problemas que contribuyen a nuestra actual crisis de inmigración están interconectados. Tus historias nos inspiran a seguir tomando una postura: cuando nuestra comunidad de viajeros y conductores sea amenazada, nosotros tomaremos las medidas pertinentes.   
                <br><br>
                En honor a Punch y su familia, nos sentimos honrados de apoyar a <a href="https://deaflatinosyfamilias.org/" target="_blank">Deaf Latinos y Familias</a>, una organización que brinda educación gratuita en el lenguaje de señas en inglés estadounidense para ayudar a las familias latinas a compartir sus tradiciones, pasajes e historia con niños, adultos sordos y personas con dificultades auditivas.
                <br><br>
                Lyft se enorgullece de ofrecer transporte para que Deaf Latinos y Familias siga realizando su vital misión. Por favor únete a nosotros para apoyarlos.
             </p>`,
      cta: 'Haz una donación',
      url: 'https://deaflatinosyfamilias.org/support'
    },
    {
      template: 'nextStoryModule',
      id: 'story-twin-cities',
      title: 'La vida después de 1991',
      location: 'Ciudades Gemelas, MN',
      alt: 'Mujer con baloncesto',
      description: 'Éxodo a las Ciudades Gemelas',
      imageSize1URL: 'assets/images/carousel/carousel-image-twin-cities-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-twin-cities-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/344699878.sd.mp4?s=7ed73e4052345395d4a29f2d53f2ff61fe2d38de&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/345095138.sd.mp4?s=1f2d61726cb7ea2c00e131b951ca03b9b573d4a9&profile_id=165'
    }
  ]
};

export default {en, es};

